<div class="h2h-dialog-row">
  <div class="title">Head to head statistics</div>
  <div class="close-box" (click)="closeDialog()">
    <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
  </div>
</div>

<div class="widgets">
  <div><div class="sr-widget sr-widget-h2h"></div></div>
</div>
